<div class="contact-us-dialog">
  <div class="contact-us-dialog__close">
    <button
      [attr.aria-label]="'registerApp_close' | translate"
      (click)="closeDialog()"
      class="contact-us-dialog__close__button"
    >
      <img role="presentation" alt="" src="./assets/icons/close16.svg" />
    </button>
  </div>

  <app-contact-us-form
    [showCancelLink]="true"
    (cancelAction)="closeDialog()"
    (submitSuccess)="closeDialog()"
  ></app-contact-us-form>
</div>
